import { LimboListingParameters } from '../constants/interfaces';
import { ApiResponse } from '../models/api/api-response.model';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { API } from '../constants/api';

@Injectable({
  providedIn: 'root',
})
export class LimboService {
  constructor(private http: HttpClient) {}

  getListing(parameters: LimboListingParameters) {
    return this.http.get<ApiResponse<any>>(API.limboListing(parameters), {
      withCredentials: true,
    });
  }
}
